var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32371 23.0807C11.0955 25.5312 13.3207 27.1538 15.9993 27.9487C18.2413 27.2834 20.1657 26.0382 21.7724 24.2131C21.3792 24.0084 21.0079 23.7675 20.6629 23.4948C19.3499 24.9506 17.7954 25.9634 15.9993 26.5333C13.6882 25.8 11.7771 24.3333 10.266 22.1333C8.7549 19.9333 7.99935 17.4889 7.99935 14.8V8.49997L15.9993 5.5256L23.9993 8.49997V11.071C24.3262 11.0242 24.6603 11 25 11C25.1115 11 25.2224 11.0026 25.3327 11.0078V7.58971L15.9993 4.10254L6.66602 7.58971V14.8C6.66602 17.8701 7.55192 20.6303 9.32371 23.0807Z",
    fill: "#C4CCDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2 14H24V17H21V18.2H24V21H25.2V18.2H28V17H25.2V14Z",
    fill: "#C4CCDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultEditor);
export default __webpack_public_path__ + "static/media/vault_editor.eef7d0f84db7de288766e5db44aedb87.svg";
export { ForwardRef as ReactComponent };